import { createApi } from '@reduxjs/toolkit/query/react';
import { DashboardResultAsDepAdmin, DashboradResultAsUpperAdmin } from '../../api/endpoints';
import { baseQueryWithReauth } from "../../api/baseQuery";

export const getResultApi = createApi({
  reducerPath: 'getResultApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getGeneralResultAsUpper: builder.query({
      query: () => ({ url: DashboradResultAsUpperAdmin, method: 'GET' }),
      providesTags: [{ type: 'GeneralResulAsUpper', id: 'GET' }],
    }),
    getGeneralResultAsDep: builder.query({
      query: () => ({ url: DashboardResultAsDepAdmin, method: 'GET' }),
      providesTags: [{ type: 'GeneralResulAsDepAdmin', id: 'GET' }],
    }),
  }),
});

export const { useGetGeneralResultAsUpperQuery, useGetGeneralResultAsDepQuery } = getResultApi;
